import * as actionTypes from "../../constants/actionTypes";
import * as handlers from "../../constants/handlers";
import * as resultCodes from "../../constants/resultCodes";
import * as messageHelper from "../../helpers/messageHelper";
import * as modelHelper from "../../helpers/modelHelper";
import * as responseHelper from "../../helpers/responseHelper";
import * as settingsHelper from "../../helpers/settingsHelper";
import * as translationHelper from "../../helpers/translationHelper";

export const processWebsocketResponse = (tabId, method, response, state) => {
    switch (method) {
        case handlers.INIT_GLOBAL_LAST_DISPENSED_FORMULAS:
            if (!responseHelper.isGetLastDispensedFormulasFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_LAST_DISPENSED_FORMULA_LIST,
                    payload: {
                        lastDispensedList: response.data
                    }
                }
            ];
        case handlers.INIT_GLOBAL_FAVORITE_FORMULAS:
            if (!responseHelper.isGetAllFavoriteFormulasFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_FAVORITE_FORMULA_LIST,
                    payload: {
                        favoritesList: response.data[0]
                    }
                }
            ];
        case handlers.INIT_GLOBAL_COLORANTS:
            if (!responseHelper.isGetAllColorantsFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_COLORANT_LIST,
                    payload: {
                        colorantList: response.data.colorantList
                    }
                }
            ];
        case handlers.INIT_GLOBAL_ALL_PRODUCTS:
            if (!responseHelper.isGroupListFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_PRODUCT_LIST,
                    payload: {
                        productList: response.data
                    }
                }
            ];
        case handlers.INIT_GLOBAL_ALL_PRODUCTS_SIMPLE:
            if (!responseHelper.isGetAllProductsSimpleFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_PRODUCT_SIMPLE_LIST,
                    payload: {
                        productList: response.data
                    }
                }
            ];
        case handlers.INIT_GLOBAL_ALL_FANDECKS:
            if (!responseHelper.isGetAllFandecksFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_FANDECK_LIST,
                    payload: {
                        fandeckList: response.data.fandeckList
                    }
                }
            ];
        case handlers.INIT_GLOBAL_MARGINS:
            if (!responseHelper.isGetAllMarginsFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_MARGIN_LIST,
                    payload: {
                        marginList: response.data.marginList
                    }
                }
            ];
        case handlers.INIT_GLOBAL_DATABASES_LIST:
            if (!responseHelper.isGetDatabasesListFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_DATABASE_LIST,
                    payload: {
                        databaseList: response.data
                    }
                }
            ];
        case handlers.INIT_GLOBAL_COMPATIBLE_SERVERS:
            if (!responseHelper.isGetRedlikeServersFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_COMPATIBLE_SERVER_LIST,
                    payload: {
                        compatibleServerList: response.data
                    }
                }
            ];
        case handlers.INIT_GLOBAL_SETTING_OPTIONS:
            if (!responseHelper.isGetSettingOptionsFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_SETTING_OPTIONS,
                    payload: settingsHelper.parseSettingOptions(response.data, state.module.productPricing)
                }
            ];
        case handlers.INIT_GLOBAL_USER_SETTINGS:
            if (!responseHelper.isGetUserSettingsFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            let validUserSettings = settingsHelper.parseUserSettings(
                response.data,
                state.settings.options,
                state.module.productPricing,
                state.module.redlikeLightSoftware,
                state.module.gammaSoftware,
                state.rcc.machine.typeName
            );

            translationHelper.setRedlikeLocale(state.lang.languages, validUserSettings.locale);

            return [
                {
                    type: actionTypes.INIT_USER_SETTINGS,
                    payload: validUserSettings
                }
            ];
        case handlers.INIT_GLOBAL_PRICE_SETTINGS:
            if (!responseHelper.isGetUserSettingsFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.INIT_PRICE_SETTINGS,
                    payload: settingsHelper.parsePricingSettings(response.data)
                }
            ];
        case handlers.INIT_GLOBAL_SERVER_CONFIGURATION:
            if (!responseHelper.isServerConfigurationValid(response)) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_SERVER_CONFIGURATION,
                    payload: {
                        multicast: response.data.Multicast.enabled
                    }
                }
            ];
        case handlers.INIT_GLOBAL_ALL_SERVER_COLORANTS:
            if (!responseHelper.isGetAllColorantsFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_ALL_COLORANT_LIST,
                    payload: {
                        colorantList: response.data.colorantList
                    }
                }
            ];
        case handlers.INIT_GLOBAL_TO_DISPENSE_GET_ORDERS:
            if (!responseHelper.isGetOrdersFormatValid(response)) {
                return [messageHelper.getFlashMessage(response)];
            }

            let orders = modelHelper.mapOrdersToObjects(response.data.orders);

            return [
                {
                    type: actionTypes.TO_DISPENSE_SAVE_ORDERS,
                    payload: {
                        orders: orders,
                        validOrder: true
                    }
                },
                {
                    type: actionTypes.TO_DISPENSE_PROCESS_NOTIFICATION_ORDERS,
                    payload: {
                        notificationOrders: orders,
                        tabId: tabId
                    }
                }
            ];
        case handlers.INIT_GLOBAL_INITIAL_DATA:
            if (response.result !== resultCodes.RESULT_OK || !responseHelper.isInitDataFormatValid(response.data)) {
                return [messageHelper.getFlashMessage(response)];
            }

            return responseHelper.handleGlobalInitDataResponse(response);
        case handlers.INIT_GLOBAL_GET_ALL_UNITS:
            if (!responseHelper.isGetAllUnitsFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_UNIT_LIST,
                    payload: {
                        unitList: response.data.units
                    }
                }
            ];
        default:
            return [
                {
                    type: actionTypes.UNKNOWN_ACTION
                }
            ];
    }
};
